<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-main-sidebar></app-main-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">
          view_headline
        </i>
        <app-navbar></app-navbar>
        <form @submit.prevent="TraineeForm">
          <div class="container-fluid mt-5">
            <div class="row">
              <div class="col-sm-12">
                <vs-breadcrumb
                  align="left"
                  :items="[
                    { title: 'You are here : ' },
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/trainee/traineeDashboard',
                      active: false
                    },
                    {
                      title: 'Profile settings',
                      url: '/#/dashboard/Trainee/TraineeReg',
                      active: true
                    }
                  ]"
                ></vs-breadcrumb>
                <div class="heading mt-3">
                  <h3 class="text-secondary">Profile Settings</h3>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-4 mb-3">
                <section class="events-panel">
                  <div class="events-panel__header">
                    <div>
                      <h5>Profile Progress</h5>
                      <small>
                        <b>Keep these sections updated for smooth participation</b>
                      </small>
                    </div>
                    <span class="events-panel__pill">
                      {{ profileComplete ? 'Ready' : 'Pending' }}
                    </span>
                  </div>
                  <div class="profile-card">
                    <article class="profile-card__item">
                      <div>
                        <h6>Basic Information</h6>
                        <small>Personal & contact details</small>
                      </div>
                      <span
                        class="status-pill"
                        :class="basicInfoComplete ? 'status-pill--success' : 'status-pill--warning'"
                      >
                        {{ basicInfoComplete ? 'Completed' : 'Pending' }}
                      </span>
                    </article>
                    <article class="profile-card__item">
                      <div>
                        <h6>Employment</h6>
                        <small>Department, designation & degree</small>
                      </div>
                      <span
                        class="status-pill"
                        :class="employmentInfoComplete ? 'status-pill--success' : 'status-pill--warning'"
                      >
                        {{ employmentInfoComplete ? 'Completed' : 'Pending' }}
                      </span>
                    </article>
                  </div>
                  <div class="profile-tip">
                    <h6>Why keep it updated?</h6>
                    <p>Accurate info ensures you receive certificates, travel documents, and event alerts on time.</p>
                    <ul>
                      <li>Use an active mobile number & email</li>
                      <li>Update department when promoted</li>
                      <li>Keep your address current</li>
                    </ul>
                  </div>
                </section>
              </div>
              <div class="col-md-8 mb-3">
                <div class="Training-pending trainee-reg-card">
                  <div class="trainee-reg-card__header">
                    <div>
                      <h5>Profile Details</h5>
                      <small>Review your information before saving</small>
                    </div>
                    <span
                      class="status-pill"
                      :class="profileComplete ? 'status-pill--success' : 'status-pill--warning'"
                    >
                      {{ profileComplete ? 'Ready' : 'Incomplete' }}
                    </span>
                  </div>
                  <div class="trainee-section">
                    <div class="section-title">
                      <div>
                        <h6>Basic Information</h6>
                        <small>Personal & contact</small>
                      </div>
                      <span>{{ basicInfoComplete ? 'Completed' : 'Pending' }}</span>
                    </div>
                    <div class="form-grid">
                      <div class="form-field">
                        <input
                          class="ref-input"
                          type="text"
                          v-model="name"
                          placeholder="Full Name *"
                        />
                      </div>
                      <div class="form-field">
                        <input
                          class="ref-input"
                          type="text"
                          v-model="passport"
                          placeholder="Passport Number"
                          disabled
                        />
                      </div>
                      <div class="form-field">
                        <input
                          class="ref-input"
                          type="text"
                          v-mask="'(99999) 9999999-9'"
                          v-model="cnic"
                          placeholder="CNIC Number"
                          disabled
                        />
                      </div>
                      <div class="form-field">
                        <input
                          class="ref-input"
                          type="text"
                          v-mask="'(9999) 9999999'"
                          v-model="mobilenumber"
                          placeholder="Mobile Number *"
                        />
                      </div>
                      <div class="form-field">
                        <input
                          class="ref-input"
                          type="email"
                          v-model="email"
                          placeholder="Email Address *"
                        />
                      </div>
                      <div class="form-field select-field">
                        <selectize
                          v-model="district"
                          :settings="districtSetting"
                          :searchable="true"
                        >
                          <option
                            v-for="(item, index) in districtArr"
                            :key="index"
                            :value="item.id"
                            :text="item.title"
                          >
                            {{ item.title }}, {{ item.province.title }}, {{ item.province.country.title }}
                          </option>
                        </selectize>
                      </div>
                      <div class="form-field full-width">
                        <textarea
                          class="ref-input textarea"
                          v-model="address"
                          placeholder="Residential Address *"
                        ></textarea>
                      </div>
                    </div>
                    <div class="gender-block">
                      <label>Gender *</label>
                      <div class="gender-options">
                        <label class="gender-pill">
                          <input type="radio" value="male" v-model="gender" />
                          <span>Male</span>
                        </label>
                        <label class="gender-pill">
                          <input type="radio" value="female" v-model="gender" />
                          <span>Female</span>
                        </label>
                        <label class="gender-pill">
                          <input type="radio" value="rather not say" v-model="gender" />
                          <span>Rather not say</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="trainee-section">
                    <div class="section-title">
                      <div>
                        <h6>Employment Information</h6>
                        <small>Department & education</small>
                      </div>
                      <span>{{ employmentInfoComplete ? 'Completed' : 'Pending' }}</span>
                    </div>
                    <div class="form-grid">
                      <div class="form-field select-field">
                        <selectize
                          v-model="departmentname"
                          :settings="departmentSetting"
                          :searchable="true"
                        >
                          <option
                            v-for="(item, index) in department"
                            :key="index"
                            :value="item.id"
                            :text="item.title"
                          >
                            {{ item.title }}
                          </option>
                        </selectize>
                      </div>
                      <div class="form-field select-field">
                        <selectize
                          v-model="designation"
                          :settings="designationSetting"
                          :searchable="true"
                        >
                          <option
                            v-for="(item, index) in designationT"
                            :key="index"
                            :value="item.id"
                            :text="item.title"
                          >
                            {{ item.title }}
                          </option>
                        </selectize>
                      </div>
                      <div class="form-field select-field">
                        <selectize
                          v-model="certificate"
                          :settings="certificateSetting"
                          :searchable="true"
                        >
                          <option
                            v-for="(item, index) in degreenameArr"
                            :key="index"
                            :value="item.id"
                            :text="item.title"
                          >
                            {{ item.title }}
                          </option>
                        </selectize>
                      </div>
                      <div class="form-field">
                        <input
                          class="ref-input"
                          type="text"
                          v-mask="'9999'"
                          v-model="passing_year"
                          placeholder="Passing Year *"
                        />
                      </div>
                      <div class="form-field">
                        <input
                          class="ref-input"
                          type="text"
                          v-model="institute"
                          placeholder="Institute *"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-actions sticky-actions">
                    <button type="button" class="ghost-btn" @click="resetForm">
                      Reset
                    </button>
                    <button type="submit" class="btn btn-primary ref-primary reg-submit">
                      Save Profile
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import MainSidebar from "./main-sidebar";
import Selectize from "vue2-selectize";
import "bootstrap/dist/css/bootstrap.css";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import axios from "axios";

export default {
  data: () => ({
    updateTraining: [],
    errors: [],
    department: [],
    designationT: [],
    name: "",
    passport: "",
    cnic: "",
    gender: "",
    mobilenumber: "",
    email: "",
    country: "",
    province: "",
    district: "",
    address: "",
    departmentname: "",
    designation: "",
    certificate: "",
    certificateSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select Degree *"
    },
    departmentSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Department *"
    },
    designationSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Designation *"
    },
    passing_year: "",
    institute: "",
    districtSetting: {
      searchField: "text",
      placeholder: "Select District *"
    },
    isSidebar: false,
    whichSelect: 0,
    options1: [
      { text: "Passport", value: 0 },
      { text: "CNIC", value: 1 }
    ],
    radios1: "",
    isForm: true,
    isFormData: false,
    contact_person: "",
    contact_number: "",
    contact_email: "",
    colorx: "#1db952",
    countryArr: [],
    provinceArr: [],
    districtArr: [],
    degreenameArr: [],
    inValid: []
  }),
  mounted() {
    axios.defaults.headers["Authorization"] = localStorage.getItem("token");
    this.fetchDepartments();
    this.fetchDesignations();
    this.fetchDistricts();
    this.fetchDegreeNames();
    this.showTraineeData();
  },
  components: {
    Selectize,
    "app-navbar": Navbar,
    "app-main-sidebar": MainSidebar
  },
  computed: {
    basicInfoComplete() {
      return (
        this.name &&
        this.gender &&
        this.mobilenumber &&
        this.email &&
        this.district &&
        this.address
      );
    },
    employmentInfoComplete() {
      return (
        this.departmentname &&
        this.designation &&
        this.certificate &&
        this.passing_year &&
        this.institute
      );
    },
    profileComplete() {
      return this.basicInfoComplete && this.employmentInfoComplete;
    }
  },
  methods: {
    fetchDepartments() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/departments/get")
        .then(response => this.handleResponse(response))
        .then(response => {
          this.department = response.data;
        });
    },
    fetchDesignations() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/trainee/designation/get")
        .then(response => this.handleResponse(response))
        .then(response => {
          this.designationT = response.data;
        });
    },
    fetchDistricts() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/districts/get")
        .then(response => this.handleResponse(response))
        .then(response => {
          this.districtArr = response.data;
        });
    },
    fetchDegreeNames() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/degreenames/get")
        .then(response => this.handleResponse(response))
        .then(response => {
          this.degreenameArr = response.data;
        });
    },
    showTraineeData() {
      const userId = JSON.parse(localStorage.getItem("currentUser"));
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/traine/show/form/" + userId.id)
        .then(response => this.handleResponse(response))
        .then(response => {
          const data = response.data;
          this.address = data.address || "";
          this.name = data.userstrainee?.name || "";
          if (data.cnic) {
            this.whichSelect = 1;
            this.cnic = data.cnic;
          }
          this.email = data.email || "";
          if (data.passportNo) {
            this.whichSelect = 0;
            this.passport = data.passportNo;
          }
          this.mobilenumber = data.userstrainee?.contactNo || "";
          this.gender = data.gender || "";
          this.district = data.district_id || "";
          this.departmentname = data.department_name || "";
          this.designation = data.designation || "";
          this.certificate = data.certificate || "";
          this.passing_year = data.passingYear || "";
          this.institute = data.institution || "";
        });
    },
    handleResponse(response) {
      if (response.data.unAuth) {
        this.$toasted.global.errorMsg("Your are Unauthorized. Need to Login Again");
        localStorage.clear();
        setTimeout(() => {
          this.$router.push("/");
        }, 1000);
        throw new Error("Unauthorized");
      }
      if (response.data.tokenExpired) {
        this.$toasted.global.errorMsg(response.data.tokenExpired);
        localStorage.clear();
        setTimeout(() => {
          this.$router.push("/");
        }, 1000);
        throw new Error("Token expired");
      }
      this.closeLoading();
      return response;
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    TraineeForm() {
      this.inValid = [];
      if (!this.gender) this.inValid.push("Gender type is required.");
      if (!this.mobilenumber) this.inValid.push("Mobile Number is required.");
      if (!this.district) this.inValid.push("District is required.");
      if (!this.address) this.inValid.push("Address is required.");
      if (!this.departmentname) this.inValid.push("Department is required.");
      if (!this.designation) this.inValid.push("Designation is required.");
      if (!this.certificate) this.inValid.push("Certificate is required.");
      if (!this.passing_year) this.inValid.push("Passing Year is required.");
      if (!this.institute) this.inValid.push("Institute is required.");

      let phone_no1 = this.mobilenumber;
      if (!phone_no1) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 11) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      let cnic_var = this.cnic;
      if (cnic_var) {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      } else if (!this.passport) {
        this.inValid.push("Please Enter Passport Number");
      }
      let passing_y = this.passing_year;
      passing_y = passing_y.replace(/_/g, "");
      if (passing_y.length < 4) {
        this.inValid.push("Must be valid YEAR, 2020");
      }
      if (this.inValid.length) {
        this.inValid.forEach(msg => this.$toasted.global.errorMsg(msg));
        return;
      }
      this.openLoading();
      axios
        .post(process.env.VUE_APP_BASE_PATH + "/register/trainee/reg", {
          user_id: JSON.parse(localStorage.getItem("currentUser")).id,
          contactNo: phone_no1,
          district: this.district,
          address: this.address,
          department_name: this.departmentname,
          designation: this.designation,
          certificate: this.certificate,
          passing_year: this.passing_year,
          institute: this.institute,
          gender: this.gender,
          email: this.email,
          name: this.name,
          type: "Details Registration"
        })
        .then(response => {
          this.closeLoading();
          if (response.data.success) {
            this.toastSuccess("Record has been updated successfully!");
            this.$router.push({ name: "traineeDashboard" });
          } else if (response.data.error) {
            throw response.data.error;
          }
        })
        .catch(error => {
          this.closeLoading();
          this.toastError(error);
        });
    },
    resetForm() {
      this.name = "";
      this.cnic = "";
      this.passport = "";
      this.gender = "";
      this.mobilenumber = "";
      this.email = "";
      this.district = "";
      this.address = "";
      this.departmentname = "";
      this.designation = "";
      this.certificate = "";
      this.passing_year = "";
      this.institute = "";
    }
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

.gender-pill {
  border: none !important;
  background: rgba(6, 166, 224, 0.1);
}

.gender-pill span {
  padding: 0.35rem 1rem;
  border-radius: 999px;
  transition: background 0.2s ease, color 0.2s ease;
}

.gender-pill input:checked + span {
  background: #06a6e0;
  color: #fff;
  box-shadow: 0 10px 25px rgba(6, 166, 224, 0.25);
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}

.events-panel {
  background: #ffffff;
  border-radius: 18px;
  padding: 1.5rem;
  height: 100%;
  min-height: 85vh;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  box-shadow: 0 20px 40px rgba(6, 166, 224, 0.12);
  border: 1px solid rgba(6, 166, 224, 0.2);
}

.events-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.events-panel__header h5 {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.95rem;
}

.events-panel__pill {
  background: linear-gradient(135deg, #06a6e0, #64d5f3);
  color: white;
  padding: 0.35rem 0.8rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.05em;
}

.profile-card {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.profile-card__item {
  border: 1px solid rgba(6, 166, 224, 0.2);
  border-radius: 14px;
  padding: 0.9rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8fbff;
}

.status-pill {
  border-radius: 999px;
  padding: 0.35rem 0.85rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.status-pill--success {
  background: rgba(34, 197, 94, 0.2);
  color: #15803d;
}

.status-pill--warning {
  background: rgba(251, 191, 36, 0.2);
  color: #b45309;
}

.profile-tip {
  background: rgba(6, 166, 224, 0.08);
  border-radius: 16px;
  padding: 1rem 1.2rem;
  color: #0c2f5c;
}

.profile-tip ul {
  padding-left: 1.2rem;
  margin: 0.5rem 0 0;
}

.Training-pending {
  border: none;
  background: linear-gradient(145deg, #f4fbff 0%, #ffffff 60%, #e6f4ff 100%);
  border-radius: 26px;
  padding: 1.75rem;
  box-shadow: 0 25px 45px rgba(6, 166, 224, 0.18);
  min-height: 85vh;
}

.trainee-reg-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.trainee-section {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 18px;
  padding: 1.3rem;
  box-shadow: 0 12px 30px rgba(6, 166, 224, 0.12);
  margin-bottom: 1.25rem;
}

.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.85rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.form-field.full-width {
  grid-column: 1 / -1;
}

.ref-input {
  border-radius: 999px;
  padding: 0.65rem 1.1rem;
  border: 1px solid rgba(6, 166, 224, 0.2);
  font-size: 0.9rem;
  transition: border 0.3s ease, box-shadow 0.3s ease;
  width: 100%;
}

.ref-input:focus {
  outline: none;
  border-color: #06a6e0;
  box-shadow: 0 0 0 3px rgba(6, 166, 224, 0.15);
}

.textarea {
  border-radius: 18px;
  min-height: 90px;
  resize: vertical;
}

.select-field :deep(.selectize-input) {
  border-radius: 999px !important;
  padding: 0.5rem 1rem;
  border: 1px solid rgba(6, 166, 224, 0.2);
}

.gender-block {
  margin-top: 1rem;
}

.gender-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: 0.5rem;
}

.gender-pill {
  border-radius: 999px;
  border: 1px solid rgba(6, 166, 224, 0.25);
  padding: 0.35rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
}

.gender-pill input {
  display: none;
}

.gender-pill span {
  font-weight: 600;
  color: #0369a1;
}

.gender-pill input:checked + span {
  color: #0c2f5c;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.ghost-btn {
  border-radius: 999px;
  padding: 0.45rem 1.2rem;
  border: 1px solid rgba(6, 166, 224, 0.3);
  background: transparent;
  font-weight: 600;
  color: #0369a1;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ref-primary {
  border-radius: 999px;
  padding: 0.6rem 1.75rem;
  border: none;
  background: linear-gradient(135deg, #06a6e0, #3fb3ff);
  box-shadow: 0 8px 20px rgba(6, 166, 224, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.gender-pill-selected {
  background: #06a6e0;
  color: #fff;
}

@media (max-width: 768px) {
  .events-panel {
    min-height: auto;
    max-height: none;
  }
  .Training-pending {
    min-height: auto;
    padding: 1.25rem;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
  .form-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .ghost-btn,
  .ref-primary {
    width: 100%;
    text-align: center;
  }
}
</style>
